import React from "react";

type Props = {
  title?: string;
};

export default function Home({ title }: Props) {
  return (
    <>
      <div
        className="out-of-Options text-center bg-danger text-white d-inline-block p-5"
        onClick={(e) => {
          alert("Vùng màu đỏ!");
          console.log(3,'đỏ');
          
        }}
      >
        <div
          className="out-of-Options text-center bg-primary text-white d-block p-5"
          onClick={(e) => {
            alert("Vùng màu xanh!");
            console.log(2,'xanh');

          }}
        >
          <div
            className="button-Options text-center bg-dark text-white d-inline-block"
            onClick={(e) => {
              alert("Vùng đen!");
              console.log(1,'đen');

            }}
          >
            Options
          </div>
        </div>
      </div>
    </>
  );
}
